module.exports = __webpack_public_path__ + "media/backgrounds/bg-orcamento-desktop-8fa04416.png";